import React, { useState, useEffect, useContext, createContext } from "react";
import { Switch, Route, Redirect, useLocation } from "react-router-dom";
import "perfect-scrollbar/css/perfect-scrollbar.css";
import makeStyles from '@mui/styles/makeStyles';
// core components
import Navbar from "components/Navbars/Navbar.js";
import Sidebar from "components/Sidebar/Sidebar.js";
import SideBarMobile from "components/Sidebar/SideBarMobile";
import routes from "routes.js";
import styles from "../assets/jss/material-dashboard-react/layouts/adminStyle.js";
import bgImage from "../assets/img/sidebar-2.jpg";
import logo from "../assets/img/reactlogo.png";

import { portalVersion } from "variables/portalVersion"
import {entra  } from 'variables/identityUrl.js'
import { AuthContext } from "../auth/authProvider.jsx";
import { CreateUrl, CallGetAPI, CallPostAPI } from 'Utils/ApiHelper.js';
import LoadingOverlay from '@ronchalant/react-loading-overlay'
import Footer from "components/Navbars/footer.tsx";
import ResetPassword from "components/Users/ResetPassword.tsx";
import ReactGA from 'react-ga4'
import { useMobileContext } from '../Context/ContextProvider'
import NavBarMobile from "../components/Navbars/NavBarMobile";
import { APIGetLoggersModel, BuildApiGetLoggers } from '../models/APIGetLoggersModel'
import ClipLoader from "react-spinners/ClipLoader";



const useStyles = makeStyles(styles);

// Create a context to pass user data to child routes
const PortalContext = createContext();



export default function Portal({ ...rest }) {
    // styles
    const classes = useStyles();
    const location = useLocation();

    const fullScreen = {
        position: 'fixed',
        width: '100%',
        height: '100%',
        left: 0,
        top: 0,
        background: 'rgba(51, 51, 51, 0.7)',
        zIndex: 10,
    }
    const DEBOUNCE_DELAY = 1500; 
    // ref to help us initialize PerfectScrollbar on windows devices
    const mainPanel = React.createRef();
    const lastClickTime = React.createRef(0);
    // states and functions
    const [image, setImage] = React.useState(bgImage);
    const [color, setColor] = React.useState("blue");
    const [fixedClasses, setFixedClasses] = React.useState("dropdown");
    const [mobileOpen, setMobileOpen] = React.useState(false);
    const usingMobile = useMobileContext()
    const handleImageClick = image => {
        setImage(image);
    };

    const handleColorClick = color => {
        setColor(color);
    };

    const handleFixedClick = () => {
        if (fixedClasses === "dropdown") {
            setFixedClasses("dropdown show");
        } else {
            setFixedClasses("dropdown");
        }
    };

    const handleDrawerToggle = () => {
        const currentTime = Date.now();
        if (currentTime - lastClickTime.current < DEBOUNCE_DELAY) {

            return; // Ignore this click
        }

        lastClickTime.current = currentTime;

        setMobileOpen(!mobileOpen);
    };

    const getRoute = () => {
        return window.location.pathname !== "/portal/maps";
    };

    const resizeFunction = () => {
        if (window.innerWidth >= 960) {
            setMobileOpen(false);
        }
    };
    const [user, setUser] = useState(null);
    const [authorised, setAuthorised] = useState(false);
    const [firstLogin, setFirstLogin] = useState(false);
    const [apiFailed, setApiFailed] = useState(false);
    const [impersonation, setImpersonation] = useState(null);
    const [userLevel, setUserLevel] = useState("restricted");
    const [lockedOut, setLockedOut] = useState(false);
    const [unknownUser, setUknownUser] = useState(false);
    const [deviceData, setDeviceData] = useState([])
    const [loading, setLoading] = useState(false)
   
    
    const authContext = useContext(AuthContext);


    const restrictedIdentities = [
        'dirk.haun@gutermann-water.com',
        'thomas.kressin@gutermann-water.com',
        'steve.gilham@gutermann-water.com',
        'julian.wilkinson@gutermann-water.com',
        'eric.galosi@gutermann-water.com'
    ]
    // Modify switchRoutes to provide context
    const switchRoutes = (user) => {
        return (          
            <PortalContext.Provider value={{ user, userLevel, deviceData }}>
                <Switch>
                    {routes.map((prop, key) => {
                        if (user && prop.layout === "/portal" && prop.roles.includes(userLevel)) {
                            return (
                                <Route
                                    path={prop.layout + prop.path}
                                    component={prop.component}
                                    key={key}
                                />
                            );
                        }
                        return null;
                    })}
 
                    <Redirect from="/portal" to="/portal/dashboard" />
                </Switch>
            </PortalContext.Provider>
        );
    };

    const passwordReset = (newPassword) => {  // returns Promise<boolean>
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                UserId: parseInt(sessionStorage.getItem('userId') || '0'),
                UserGuid: sessionStorage.getItem('userGuid') || '',
                oldPassword: "",
                newPassword: newPassword,
            })
        };

        return new Promise(
            function (resolve) {
                CallPostAPI(CreateUrl('/api/aquaguard/UserPassword'), requestOptions)
                    .then((data) => {
                        resolve(true);
                    })
                    .catch(function (error) {
                        resolve(false);
                        console.log(error);
                    });
            }
        );
    }

    const resetDone = () => {
        setFirstLogin(false);
        setAuthorised(true);
        setLockedOut(false);
    }



    const getDeviceData = (company) => {
        setLoading(true)
        //const company = sessionStorage.getItem('companyId')
        console.log(company)
        CallGetAPI(CreateUrl('/api/aquaguard/getloggers?companyId=' + company + '&filterGroup=' + sessionStorage.getItem('filterGroupId')), {})
            .then((data) => {
                const deviceDataTemp = []
                data.forEach(d => deviceDataTemp.push(BuildApiGetLoggers(d)))
                setDeviceData(deviceDataTemp)
                //setAuthorised(true);
            })
            .catch(err => {
                console.error(err)
                //setAuthorised(true);
            })
    }

    // initialize and destroy the PerfectScrollbar plugin
    useEffect(() => {
        let userTemp
        if (localStorage.getItem('portalVersion') !== portalVersion) {
            window.sessionStorage.setItem('portalUpdate', "true")
            localStorage.setItem('showPopup', true)
        }
        authContext.getUser()
            .then(function (user) {
                console.log(user)
                window.sessionStorage.setItem('loginError', false);
                window.sessionStorage.setItem('unknownUser', false);
                userTemp = user
        if (entra) {
            callEntraLogin(userTemp)
        } else {
            callNonEntraLogin(userTemp)
                }
            });
    }, []);


    const callEntraLogin = (user) => {
    console.log(user)
        CallGetAPI(CreateUrl(`/api/aquaguard/ResolveIdentityEntra?useremail=${user.profile.email}&impersonated=false`), {})
            .then(data => { console.log(data) })
            .catch(err =>console.error(err))
    }



    const callNonEntraLogin = (user) => {
        
        console.log(user)
                if (user.profile.userlevel != 'identityadmin') {
                    CallGetAPI(CreateUrl('/api/aquaguard/ResolveIdentity?company=' + user.profile.company.toString() + '&user=' + user.profile.sub.toString() + "&impersonated=false"), {})
                        .then(data => {
                            console.log(data)
                            // Check if user is locked out
                            if (data.lockedOut) {
                                setLockedOut(true);
                                setAuthorised(true);
                            }
                            else {
                                setAuthorised(true);
                                window.sessionStorage.setItem('loginError', false);
                                window.sessionStorage.setItem('companyId', data.companyId);
                                window.sessionStorage.setItem('companyGuid', user.profile.company.toString());
                                window.sessionStorage.setItem('userId', data.userId);
                                window.sessionStorage.setItem('userLevel', user.profile.userlevel);
                                window.sessionStorage.setItem('userGuid', user.profile.sub.toString());
                                window.sessionStorage.setItem('filterGroupId', data.filterGroup ? data.filterGroup : '0');
                                window.sessionStorage.setItem('filterGroupName', data.filterGroupName ? data.filterGroupName : "");
                                window.sessionStorage.setItem('dashboardJson', data.dashboardJson ? data.dashboardJson : "");
                                window.sessionStorage.setItem('companyName', data.companyName);
                                window.sessionStorage.setItem("flowUnits", data.flowUnits);
                                window.sessionStorage.setItem("utcOffset", data.utcOffset > 0 ? "+" + data.utcOffset : data.utcOffset);
                                window.sessionStorage.setItem('favourites', data.favourites)
                                window.sessionStorage.setItem('inactiveTimeframe', data.inactiveTimeframe)
                                window.sessionStorage.setItem("canConfig", data.canConfig);
                                window.sessionStorage.setItem('graphTotaliser', data.graphTotaliser)
                                window.sessionStorage.setItem('userName', user.profile.name)
                                window.sessionStorage.setItem('language', data.language)

                                localStorage.setItem('portalVersion', portalVersion)
                                
                                window.sessionStorage.setItem('inactiveTimeframe', data.inactiveTimeframe ? data.inactiveTimeframe : "24 Hours")
                                setUserLevel(user.profile.userlevel);
                                setFirstLogin(data.firstLogin);

                                let bValidServer = data.validServer;
                                bValidServer = true; //QUICK FIX, AG CLOUD Returns False, as reverse proxy in place so it cant match the users registered servers
                                if (bValidServer) {
                                    setUser(user);
                                }
                                setAuthorised(true);
                                getDeviceData(data.companyId)
                            }
                        },
                            // Reject
                            (responsedata) => {
                                if (responsedata.status == 404) {
                                    console.log('ResolveIdentity Not Found Error');
                                    window.sessionStorage.setItem('loginError', true);
                                    window.sessionStorage.setItem('unknownUser', true);

                                    setAuthorised(true);
                                    setUknownUser(true);
                                } else
                                    setApiFailed(true);
                            })
                        .catch(function (error) {
                            console.log(error)
                        });
                }
                else {
                    if (window.sessionStorage.getItem('impersonateUser')) {
                        CallGetAPI(CreateUrl('/api/aquaguard/ResolveIdentity?company=' + window.sessionStorage.getItem('impersonateCompany') + '&user=' + window.sessionStorage.getItem('impersonateUser') + "&impersonated=true"), {})
                            .then(data => {
                                window.sessionStorage.setItem('companyId', data.companyId);
                                window.sessionStorage.setItem('companyGuid', window.sessionStorage.getItem('impersonateCompany'));

                                window.sessionStorage.setItem('userId', data.userId);
                                window.sessionStorage.setItem('userLevel', data.userRole);
                                window.sessionStorage.setItem('userGuid', window.sessionStorage.getItem('impersonateUser'));
                                window.sessionStorage.setItem('filterGroupId', data.filterGroup ? data.filterGroup : 0);
                                window.sessionStorage.setItem('filterGroupName', data.filterGroupName ? data.filterGroupName : "");
                                window.sessionStorage.setItem('dashboardJson', data.dashboardJson ? data.dashboardJson : "");
                                window.sessionStorage.setItem('companyName', data.companyName);
                                window.sessionStorage.setItem("flowUnits", data.flowUnits);
                                window.sessionStorage.setItem("utcOffset", data.utcOffset > 0 ? "+" + data.utcOffset : data.utcOffset);
                                window.sessionStorage.setItem("canConfig", data.canConfig);
                                window.sessionStorage.setItem('graphTotaliser', data.graphTotaliser)
                                localStorage.setItem('portalVersion', portalVersion)
                                window.sessionStorage.setItem('favourites', data.favourites)
                                window.sessionStorage.setItem('inactiveTimeframe', data.inactiveTimeframe)
                                window.sessionStorage.setItem('language', data.language)
                                window.sessionStorage.setItem('userName', data.userName)

                                setImpersonation(data.userName + " [" + data.companyName + "]");
                                setUserLevel(data.userRole);
                                setUser(user);
                                setLockedOut(false);
                                setAuthorised(true);
                                getDeviceData(data.companyId)
                            },
                                // Reject
                                (responsedata) => {
                                    if (responsedata.status == 404) {
                                        console.log('ResolveIdentity Not Found Error');
                                        window.sessionStorage.setItem('loginError', true);
                                    } else
                                        setApiFailed(true);
                                })
                            .catch(function (error) {
                                console.log(error)
                            });
                    }
                    else {
                        if (!window.location.hostname.includes('zonelog.net') && restrictedIdentities.includes(user.profile.email)) {
                            window.location.href = '/'
                        } else {
                            window.sessionStorage.setItem('companyId', 0);
                            window.sessionStorage.setItem('companyGuid', user.profile.company.toString());
                            window.sessionStorage.setItem('userId', 0);
                            window.sessionStorage.setItem('userLevel', user.profile.userlevel);
                            window.sessionStorage.setItem('userGuid', user.profile.sub.toString());
                            window.sessionStorage.setItem('filterGroupId', 0);
                            window.sessionStorage.setItem('filterGroupName', "");
                            window.sessionStorage.setItem('dashboardJson', "");
                            window.sessionStorage.setItem('companyName', "Ashridge");
                            window.sessionStorage.setItem("utcOffset", "0");
                            window.sessionStorage.setItem('favourites', user.favourites)
                            window.sessionStorage.setItem('inactiveTimeframe', user.inactiveTimeframe)
                            window.sessionStorage.setItem("canConfig", "true");
                            window.sessionStorage.setItem('graphTotaliser', 'true')
                            window.sessionStorage.setItem('language', 'en-GB')
                            window.sessionStorage.setItem('userName', user.profile.name)
                            localStorage.setItem('portalVersion', portalVersion)
                            window.sessionStorage.setItem('inactiveTimeframe', user.inactiveTimeframe)

                            setUserLevel(user.profile.userlevel);
                            setFirstLogin(false);
                            setUser(user);
                            setLockedOut(false);
                            setAuthorised(true);
                            getDeviceData(0)
                        }
                    }
                }
                //if (usingMobile) {
                
                //}
           
    }





    // Add analytics tracking that updates on location/route changes
    useEffect(() => {
        if (user) {
            try {
                const currentDomain = window.location.hostname;

                const analyticsConfig = {
                    'aquaguard.cloud': process.env.REACT_APP_GA_MEASUREMENT_ID_MAIN,
                    'sww.aquaguard.cloud': process.env.REACT_APP_GA_MEASUREMENT_ID_SWW,
                    'zonelog.net': process.env.REACT_APP_GA_MEASUREMENT_ID_ZONELOG,
                    'dataloggers.capnuocthuduc.vn': process.env.REACT_APP_GA_MEASUREMENT_ID_HUNGVIET,
                    'dev.aquaguard.cloud': process.env.REACT_APP_GA_MEASUREMENT_ID_DEV
                };

                const measurementId = analyticsConfig[currentDomain] ||
                    process.env.REACT_APP_GA_MEASUREMENT_ID_DEFAULT ||
                    '';

                if (measurementId && !window.gaInitialized) {

                    ReactGA.initialize(measurementId);
                    window.gaInitialized = true;
                } else if (!measurementId) {
                    console.warn('GA Measurement ID not found for domain:', currentDomain);
                    return; //
                }

                // Set user and session data
                ReactGA.set({
                    server_instance: currentDomain,
                    userId: user.profile.sub,
                    userRole: userLevel,
                    authenticated: true,
                    platform: navigator.platform,
                    screenResolution: window.screen.width + "x" + window.screen.height,
                    viewportSize: window.innerWidth + "x" + window.innerHeight,
                    language: navigator.language
                });

                // Track page view on every location change
                ReactGA.send({
                    hitType: "pageview",
                    page: location.pathname,
                    title: document.title
                });

                // Initialize or update user flow tracking
                if (!window.userFlowPath) {
                    window.userFlowPath = [];
                    window.entryTimestamp = Date.now();
                    window.previousPath = null;

                    // Track session start
                    ReactGA.event({
                        category: 'User Flow',
                        action: 'Session Started',
                        label: location.pathname
                    });
                }

                const currentPath = location.pathname;

                // If this is a new page (not just a re-render)
                if (window.previousPath !== currentPath) {
                    // Add to user flow path
                    window.userFlowPath.push(currentPath);

                    // Track navigation between pages
                    if (window.previousPath) {
                        // Track the navigation event
                        ReactGA.event({
                            category: 'User Flow',
                            action: 'Navigation',
                            label: window.previousPath + " -> " + currentPath
                        });

                        // Track time spent on previous page
                        const timeSpentMs = Date.now() - window.pageEntryTimestamp;
                        ReactGA.timing({
                            category: 'Engagement',
                            variable: 'Time On Page',
                            value: timeSpentMs,
                            label: window.previousPath
                        });
                    }

                    // Update tracking variables
                    window.previousPath = currentPath;
                    window.pageEntryTimestamp = Date.now();
                }

            } catch (error) {
                console.error('Error with Google Analytics tracking:', error);
            }
        } 
    }, [location, user, userLevel]);

    // Add a cleanup function for when the user leaves
    useEffect(() => {
        // Function to handle user leaving the site
        const handleBeforeUnload = () => {
            if (window.userFlowPath && window.userFlowPath.length > 0) {
                try {
                    // Track total session duration
                    const sessionDuration = Date.now() - window.entryTimestamp;

                    ReactGA.event({
                        category: 'User Flow',
                        action: 'Session Ended',
                        label: window.location.pathname,
                        value: Math.floor(sessionDuration / 1000) // Convert to seconds
                    });

                    // Track full user path
                    ReactGA.event({
                        category: 'User Flow',
                        action: 'Complete Path',
                        label: window.userFlowPath.join(' -> ')
                    });
                } catch (error) {
                    console.error('Error tracking session end:', error);
                }
            }
        };

        // Add event listener for when user leaves
        window.addEventListener('beforeunload', handleBeforeUnload);

        // Clean up
        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, []);

    return (
        <div>
            {console.log('hitting return') }
            {(authorised) ?
                (firstLogin) ?
                    <>
                        {console.log('first login') }
                        <ResetPassword onSet={passwordReset} resetDone={resetDone} classes={classes} />
                    </>
                    :
                    (!lockedOut) ?

                        (unknownUser) ?
                            <Redirect to={'/Login'} />
                            :
                            (user) ?
                                (usingMobile) ? <div>
                                        <NavBarMobile
                                            handleDrawerToggle={handleDrawerToggle}
                                            open={mobileOpen}
                                            impersonateUser={impersonation}
                                            user={user.profile}
                                            deviceData={deviceData}
                                            />
                                    {mobileOpen &&
                                        <SideBarMobile
                                        routes={routes}
                                        handleDrawerToggle={handleDrawerToggle}
                                        open={mobileOpen}
                                        //color={color}
                                        {...rest}
                                    >
                                        </SideBarMobile>}
                                    {getRoute() ? (
                                        <div className={classes.content}>
                                            <div className={classes.container}>{switchRoutes(user, deviceData)}</div>
                                        </div>
                                    ) : (
                                        <div className={classes.map}>{switchRoutes(user, deviceData)}</div>
                                    )}
                                    <Footer />
                                </div> 
                                :
                                    <div className={classes.wrapper} >

                                    {mobileOpen && <Sidebar
                                        routes={routes}
                                        logoText={window.location.hostname.includes('zonelog.net') ? "ZONELOG" : "AquaGuard"}
                                        logo={logo}
                                        image={image}
                                        handleDrawerToggle={handleDrawerToggle}
                                        open={mobileOpen}
                                        color={color}
                                        {...rest}
                                        />}
                                    <div className={classes.mainPanel} ref={mainPanel}>
                                        <Navbar
                                            logoText={window.location.hostname.includes('zonelog.net') ? "ZONELOG" : "AquaGuard"}
                                            routes={routes}
                                            handleDrawerToggle={handleDrawerToggle}
                                                impersonateUser={impersonation}
                                                deviceData={deviceData}
                                            {...rest}
                                        />

                                        {getRoute() ? (
                                            <div className={classes.content}>
                                                <div className={classes.container}>{switchRoutes(user)}</div>
                                            </div>
                                        ) : (
                                            <div className={classes.map}>{switchRoutes(user)}</div>
                                        )}
                                        <Footer />
                                    </div>
                                </div>
                                :
                                <Redirect to={'/Login'} />
                        :
                        <Redirect to={'/Lockout'} />
                :
                (apiFailed) ?
                    <div className="error">The system has failed to respond. Please contact the System Administrator</div>
                    :
                    <LoadingOverlay
                        active={true}
                        spinner
                        text='Processing your login...'
                        styles={{ wrapper: fullScreen }}
                    >
                        <p>loading - callback</p>
                    </LoadingOverlay>}
        </div>          
    );
}

// Create a hook to use the portal context in child components
export function usePortalContext() {
    return useContext(PortalContext);
}